export default "<button type=\"button\" (click)=\"goBack()\" class=\"back-button\">\n  <mat-icon>chevron_left</mat-icon>\n  Back\n</button>\n";